import { render, staticRenderFns } from "./edit_bis.vue?vue&type=template&id=2c93942c"
import script from "./edit_bis.vue?vue&type=script&lang=ts"
export * from "./edit_bis.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports